<template>
  <div class="relative">
    <div
      v-if="pleaseCamera"
      class="absolute top-0 left-0 w-full h-full bg-danger z-[1] pb-8 bg-opacity-75 backdrop-blur-md flex items-center justify-center"
    >
      <div class="text-secondary p-4">
        <v-icon name="md-warning-round" scale="7.5" class="absolute opacity-25 -translate-x-1/2 -translate-y-1/4" />
        <p class="font-bold text-xl">Maaf!</p>
        <p>{{ pleaseCamera }}</p>
        <p class="mt-2 italic text-center">(Coba ganti ke kamera lain)</p>
      </div>
    </div>
    <qrcodeStream class="" @decode="onDetectQR" :paused="isDone" :track="paintOutline" @error="logErrors" />
  </div>
</template>

<style>
  /*
  .qrcode-stream-overlay {
    position: absolute;
    top: 0;
    left: 0;
  }
  .qrcode-stream-wrapper {
    position: relative;
    overflow: hidden;
  }
  .qrcode-stream-camera--hidden.qrcode-stream-camera {
    display: none;
  }
    */
</style>

<script>
  // import { ref, onMounted, defineProps, defineEmits } from "vue";
  import { QrcodeStream } from "vue-qrcode-reader";

  export default {
    name: "QRForm",
    components: {
      QrcodeStream
    },
    data() {
      return {
        isDone: false,
        pleaseCamera: "",
        cameraSelected: { facingMode: "environment" }
      };
    },
    props: {},
    emits: ["detect"],
    methods: {
      logErrors(e) {
        console.error(e);
        this.pleaseCamera = e.message;
      },
      onDetectQR(decodedString) {
        this.isDone = true;
        const checkId = this.idChecking(decodedString);
        if (checkId) {
          this.$emit("detect", checkId);
          return;
        }
      },
      idChecking(decodedString) {
        const checkId = decodedString.match(/^ky\.time\.loc:([0-9a-f]{8}-([0-9a-f]{4}-){3}[0-9a-f]{12})/);
        if (checkId) {
          return checkId[1];
        }
        return null;
      },
      // paintOutline(detectedCodes, ctx) {
      //   for (const detectedCode of detectedCodes) {
      //     const [firstPoint, ...otherPoints] = detectedCode.cornerPoints;
      //     ctx.strokeStyle = "red";
      //     ctx.lineWidth = 5;
      //     ctx.beginPath();
      //     ctx.moveTo(firstPoint.x, firstPoint.y);
      //     for (const { x, y } of otherPoints) {
      //       ctx.lineTo(x, y);
      //     }
      //     ctx.lineTo(firstPoint.x, firstPoint.y);
      //     ctx.closePath();
      //     ctx.stroke();
      //   }
      // },
      paintOutline(detectedCodes, ctx) {
        const idC = this.idChecking(detectedCodes[0]?.rawValue);
        for (const detectedCode of detectedCodes) {
          const [firstPoint, ...otherPoints] = detectedCode.cornerPoints;
          const secondPoint = otherPoints[0];

          // Draw outline
          if (idC) ctx.strokeStyle = "green";
          else ctx.strokeStyle = "red";

          ctx.lineWidth = 5;
          ctx.beginPath();
          ctx.moveTo(firstPoint.x, firstPoint.y);
          for (const { x, y } of [...otherPoints, firstPoint]) {
            ctx.lineTo(x, y);
          }
          ctx.closePath();
          ctx.stroke();

          // Calculate angle between first and second point
          if (!idC) {
            const dx = secondPoint.x - firstPoint.x;
            const dy = secondPoint.y - firstPoint.y;
            const angle = Math.atan2(dy, dx);

            // Draw rotated text
            ctx.save(); // Save context before transform
            ctx.translate(firstPoint.x + 10, firstPoint.y + 10); // Move origin to text position
            ctx.rotate(angle); // Rotate to align with the top edge
            ctx.font = "16px Arial";

            ctx.lineWidth = 3;
            ctx.strokeStyle = "white"; // Outline color
            ctx.strokeText("Tidak Valid", 0, 0);
            ctx.fillStyle = "red";
            ctx.fillText("Tidak Valid", 0, 0); // Draw text at the new origin
            ctx.restore(); // Restore original context
          }
        }
      }
    }
  };
</script>
